<template>
  <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
      <h5 class="label-black" style="margin-bottom: 0px;">NUEVO DOCUMENTO</h5>
      <h6 class="label-black" style="margin-top: 0px;">Registro de documentos sin referencia</h6>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
        <div class="area custom-area">
          <div id="Captura_div">
            <div class="row">
              <div class="form-group col-4">
                <h6 class="label-black"> Datos del Documento</h6>
              </div>
            </div>
            <div v-if="AreaUsuario.Area.AreaId==21 && AreaUsuario!=null">
              <div class="row">
                <div class="form-group col-4" id="Area_div">
                  <label class="label-black">Área</label>
                  <CAreas v-on:valorParaElPadre="cambioDeArea"
                          :prefijo="enumeraciones.etiquetasDeHTML.Select"
                          :tipo="enumeraciones.tiposDeSelect.Seleccione"
                          :idDelInput="'filtroDeBusqueda_Area'"
                          :parametros="parametros_Area"
                          :valorDefinido="parametros_Area.areaId"
                          :key="parametros_Area.areaId"
                          >
                  </CAreas>
                </div>
                <div class="form-group col-4" id="Mataria_div" v-if="parametros_Area.areaId>0">
                  <label class="label-black">Materia</label>
                  <CMateria v-on:valorParaElPadre="cambioDeMateria"
                            :prefijo="enumeraciones.etiquetasDeHTML.Select"
                            :tipo="enumeraciones.tiposDeSelect.Seleccione"
                            :idDelInput="'filtroDeBusqueda_Materia'"
                            :parametros="parametros_Materia"
                            :valorDefinido="parametros_Materia.materiaId"
                            :key="parametros_Materia.materiaId">
                  </CMateria>
                </div>
                <div class="form-group col-4" id="Area_div" v-if="parametros_Materia.materiaId>0">
                  <label class="label-black">Tipo de Documento</label>
                  <CTipoDocumento v-on:valorParaElPadre="cambioDocumento"
                                  :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                  :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                  :idDelInput="'filtroDeBusqueda_Documento'"
                                  :parametros="parametros_TipoDocumento"
                                  :valorDefinido="parametros_TipoDocumento.tipoDocumentoId"
                                  :key="parametros_TipoDocumento.tipoDocumentoId">
                  </CTipoDocumento>
                </div>
              </div>
              <div class="row" v-if="parametros_TipoDocumento.tipoDocumentoId>0">
                <!-- <div class="form-group col-4" id="Anio_div">
                  <label>Año</label>
                  <input type="number" class="form-control" placeholder="####" v-model="Documento.Año" />
                </div>
                <div class="form-group col-4" id="Consecutivo_div">
                  <label>Consecutivo</label>
                  <input type="number" class="form-control" placeholder="####" v-model="Documento.Consecutivo" />
                </div> -->

                <div class="form-group col-4" id="consecutivo_div">
                  <label class="label-black">Consecutivo</label>
                  <input class="form-control" type="text" placeholder="####/####" v-model="inputConsecutivo" v-mask="'####/####'"  @keyup="ObtenerAnio($event)" />
                </div>
              <!-- </div>
                <div class="form-group col-4" id="Estatus_div">
                  <label>Estatus del Documento</label>
                  <CEstatus v-on:valorParaElPadre="cambioDeEstatus"
                            :prefijo="enumeraciones.etiquetasDeHTML.Select"
                            :tipo="enumeraciones.tiposDeSelect.Seleccione"
                            :idDelInput="'Busqueda_TipoEstatus'"
                            :valorDefinido="parametros_TipoInventario.tipoEstatusInventarioDocumentoId"
                            :parametros="parametros_TipoInventario"
                            :key="parametros_TipoInventario.tipoEstatusInventarioDocumentoId">
                  </CEstatus>
                </div> -->
              </div>
              <div class="row">
                <div class="form-group col-2 text-left" id="BtnGuardar" v-if="parametros_TipoDocumento.tipoDocumentoId>0">
                  <button class="btn btn-success" @click='GuardaDocumento()'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Guardar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
                <div class="form-group col-2 text-left" id="BtnCancelar">
                  <button class="btn btn-danger" @click='Inicio()'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cancelar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
              </div>
            </div>
            <div v-if="AreaUsuario.Area.AreaId!=21 && AreaUsuario!=null">
              <div class="row">
                <div class="form-group col-4" id="Area_div">
                  <label class="label-black">Área</label>
                  <input type="text" class="form-control" v-model="AreaUsuario.Area.Nombre" readonly/>
                </div>
                <div class="form-group col-4" id="Mataria_div" v-if="AreaUsuario.Area.AreaId>0">
                  <label class="label-black">Materia</label>
                  <CMateria v-on:valorParaElPadre="cambioDeMateria"
                            :prefijo="enumeraciones.etiquetasDeHTML.Select"
                            :tipo="enumeraciones.tiposDeSelect.Seleccione"
                            :idDelInput="'filtroDeBusqueda_Materia'"
                            :parametros="parametros_Materia"
                            :valorDefinido="parametros_Materia.materiaId"
                            :key="parametros_Materia.materiaId">
                  </CMateria>
                </div>
                <div class="form-group col-4" id="Area_div" v-if="parametros_Materia.materiaId>0">
                  <label class="label-black">Tipo de Documento</label>
                  <CTipoDocumento v-on:valorParaElPadre="cambioDocumento"
                                  :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                  :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                  :idDelInput="'filtroDeBusqueda_Documento'"
                                  :parametros="parametros_TipoDocumento"
                                  :valorDefinido="parametros_TipoDocumento.tipoDocumentoId"
                                  :key="parametros_TipoDocumento.tipoDocumentoId">
                  </CTipoDocumento>
                </div>
              </div>
              <div class="row" v-if="parametros_TipoDocumento.tipoDocumentoId>0 && parametros_Materia.materiaId>0">
                <div class="form-group col-4" id="consecutivo_div">
                  <label class="label-black">Consecutivo</label>
                  <input class="form-control" type="text" placeholder="####/####" v-model="inputConsecutivo" v-mask="'####/####'"  @keyup="ObtenerAnio($event)" />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-2 text-left" id="BtnGuardar" v-if="parametros_TipoDocumento.tipoDocumentoId>0 && parametros_Materia.materiaId>0">
                  <button class="btn btn-success" @click='GuardaDocumento()'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Guardar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
                <div class="form-group col-2 text-left" id="BtnCancelar">
                  <button class="btn btn-danger" @click='Inicio()'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cancelar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'

export default {
    data(){
        return{
            enumeraciones,
            inputConsecutivo: "",
            Documento: {
                Año: "",
                Consecutivo: "",
            },
            Volumenes: {
                Fojas:0,
                Contenedor: 0,
            },
            parametros_Area: {
                areaId: -1,
                conMaterias: true,
                conOrdenamientoPorSistema: true
            },
            parametros_TipoDocumento: {
                tipoDocumentoId: -1,
                areaId: -1,
                materiaId: -1,
                soloDocumentosPrincipales: true,
                nombre:""
            },
            parametros_TipoInventario: {
                tipoEstatusInventarioDocumentoId: -1
            },
            parametros_Materia:{
                materiaId: -1,
                areaId: -1
            },
            parametros_Sede:{
                sedeArchivoId: -1
            },
            AreaUsuario: {
              Area: {
                AreaId: 0,
                Nombre: null
              }
              
            }
        }
    },
    components:{
      CAreas : catalogos.ArchivoJudicial.C001Areas,
      CTipoDocumento: catalogos.PJ.C004TipoDocumento,
      CMateria: catalogos.PJ.C002Materias,
      CEstatus : catalogos.ArchivoJudicial.C003TipoEstatusDocumento,
      CSedes: catalogos.ArchivoJudicial.C012SedesArchivo
    },

    methods:{
        cambioDeArea(datos){
            this.parametros_Area.areaId = parseInt(datos[0].target.value);
            if(this.parametros_Area.areaId>0)
            {
              this.parametros_TipoDocumento.areaId = datos[1].AreaId;
              this.parametros_Materia.areaId = datos[1].AreaId;
              if(datos[1].Materias.length==1)
              {
                this.parametros_Materia.materiaId = parseInt(datos[1].Materias[0].MateriaId)
                this.parametros_TipoDocumento.materiaId = datos[1].Materias[0].MateriaId
              }
            }
           
            if(this.parametros_Area.areaId==-1)
            {
              this.parametros_Materia.materiaId=-1;
              this.parametros_TipoDocumento.materiaId=-1;
              this.parametros_TipoDocumento.areaId =-1;
              this.parametros_TipoDocumento.tipoDocumentoId=-1;

            }
            
            //console.log(this.parametros_Materia.materiaId)
        },
        cambioDocumento(datos){
            this.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);
        },
        cambioDeEstatus(datos){
            this.parametros_TipoInventario.tipoEstatusInventarioDocumentoId = parseInt(datos.target.value);
        },
        cambioDeMateria(datos){
            this.parametros_Materia.materiaId = parseInt(datos.target.value);
        },
        cambioDeSede(datos){
            this.parametros_Sede.sedeArchivoId= parseInt(datos.target.value);
        },
        GuardaDocumento() {
            if(this.ValidaDatos())
            {
              let tipoMateria = this.parametros_Materia.materiaId;
              if(this.parametros_Area.areaId==17 ||this.parametros_Area.areaId==18 || this.parametros_Area.areaId==24 || this.parametros_Area.areaId==29)
              {
                if(this.parametros_Materia.materiaId!=6)
                {
                   tipoMateria = 10;
                }
              };
              var peticion = {
                  "InventarioDocumentos": {
                      "Area": {"AreaId": this.AreaUsuario.Area.AreaId==21 ? this.parametros_Area.areaId : this.AreaUsuario.Area.AreaId},
                      "Materia": {"MateriaId": tipoMateria}, //this.parametros_Materia.materiaId},
                      "TipoDocumento": {"TipoDocumentoId": this.parametros_TipoDocumento.tipoDocumentoId},
                      "Anio": this.Documento.Año,
                      "Consecutivo": this.Documento.Consecutivo,
                      "TipoEstatusInventario": {"TipoEstatusInventarioDocumentoId": 1},
                      "SedeArchivo" : {"SedeArchivoId": 0}
                  },
                  "Volumenes" : {
                      "Fojas": this.Volumenes.Fojas,
                      "Contenedor": this.Volumenes.Contenedor,
                  }
              };
              comun.SeEstaCargandoInformacion(true);

              axios.post(api.conexion + api.ArchivoJudicial.NuevoDocumento, peticion,
              comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
              .then( respuesta => {
                  if(respuesta.data.SiHayError)
                  {
                      console.log(respuesta);
                      comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                      this.VaciaDatos();
                  }
                  else
                  {
                      comun.SeEstaCargandoInformacion(false);
                      comun.mensajeDeAlerta("Se ha registrado el Documento satisfactoriamente", null, null);
                      this.VaciaDatos();
                  }
                  comun.SeEstaCargandoInformacion(false);

              })
              .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
            })
            }
        },
        VaciaDatos(){
            this.Documento.Año = "";
            this.Documento.Consecutivo = "";
            this.parametros_Area.areaId = -1;
            this.parametros_TipoDocumento.tipoDocumentoId = -1;
            this.parametros_Materia.materiaId = -1;
            this.parametros_TipoInventario.tipoEstatusInventarioDocumentoId = -1;
            this.parametros_Sede.sedeArchivoId = -1;
            this.Volumenes.Fojas ="";
            this.Volumenes.Contenedor="";
            this.inputConsecutivo="";
        },
        ValidaDatos(){
            if(this.AreaUsuario.Area.AreaId==21 &&(this.parametros_Area ==null || this.parametros_Area.areaId == -1))
            { comun.mensajeDeAlerta("Indicar el área del Documento.", null, null);
            return false;}
            if(this.parametros_TipoDocumento ==null || this.parametros_TipoDocumento.tipoDocumentoId == -1)
            { comun.mensajeDeAlerta("Indicar el tipo del Documento.", null, null);
            return false;}
            if(this.parametros_Materia ==null || this.parametros_Materia.materiaId == -1)
            { comun.mensajeDeAlerta("Indicar la materia correspondiente del documento.", null, null);
            return false;}
            // if(this.parametros_TipoInventario ==null || this.parametros_TipoInventario.tipoEstatusInventarioDocumentoId == -1)
            // { comun.mensajeDeAlerta("Indicar el Estatus del Documento.", null, null);
            // return false;}
            // if(this.parametros_Sede ==null || this.parametros_Sede.sedeArchivoId == -1)
            // { comun.mensajeDeAlerta("Indicar sede de resguardo.", null, null);
            // return false;}

            if(this.inputConsecutivo == null || this.inputConsecutivo.Año == "")
            {comun.mensajeDeAlerta("Completar el consecutivo del Documento.", null, null);
            return false;}
            if(this.inputConsecutivo.length < 9)
            {comun.mensajeDeAlerta("Completar el consecutivo del Documento", null, null);
            return false;}
            // if(this.Documento.Consecutivo == null || this.Documento.Consecutivo == "")
            // {comun.mensajeDeAlerta("Completar el consecutivo del Documento.", null, null);
            // return false;}
            // if(this.Documento.Consecutivo.length != 4)
            // {comun.mensajeDeAlerta("Formato de Consecutivo debe ser 4 digitos.", null, null);
            // return false;}
           
            return true;

        },
        Inicio(){
            router.push({name: "ArchivoJudicial"});
        },
        ObtenerAnio(event){ //Agregado para los documento de medidas de seguridad y ejecucion
            var longitud = event.target.value.length;
            if(longitud==9)
            {
                this.Documento.Año = event.target.value.substr(5,4);
                this.Documento.Consecutivo = event.target.value.substr(0,4);
            }
        }
    },
    mounted(){
      this.AreaUsuario = this.$store.state.Login_Usuario;
      if(this.AreaUsuario.Area.AreaId!=21)
      {
        this.parametros_Materia.areaId = this.AreaUsuario.Area.AreaId
        this.parametros_TipoDocumento.areaId = this.AreaUsuario.Area.AreaId
      }
    }
}
</script>
<style scoped>
  input[type="text"]:read-only {
    background: #f3f3f3;
  }
  input[type="text"]:read-only:focus {
    color: #fff;
  }
  .custom-area {
  background-color: #7e7f74;
  }
  .label-black {
    color: black;
  }
  .btn-custom {
    background-color: #004746;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Inventario/NuevoDocumento.vue